import React from "react";
import { useCheckPermission } from "@shared/hooks";
import type { PERMISSION } from "@shared/constants";

export interface AccessControlProps {
  permission?: PERMISSION | PERMISSION[];
  children?: React.ReactNode;
}

const AccessControl = (props: AccessControlProps) => {
  const { permission, children } = props;

  const permitted = useCheckPermission(permission);

  return permitted ? <>{children}</> : null;
};

export default AccessControl;
